/* VNSTRA: rekenhulp en formulierkoppeling voor /pages/keuken-laten-wrappen (08-10-2026).
   Geen externe scripts, geen eval. Prijzen komen uit data-attributen (sectie-instellingen). */
(function () {
  'use strict';

  /* GW 25-10-2026: teksten taalafhankelijk (DE/EN) */
  var GW_LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var GW_T = {
    de: { fill: 'Gib oben ein, was foliert werden soll', min: ' (Mindestpreis)', step: 'Schritt ', of: ' von ', dur: ' · dauert etwa eine Minute', loc: 'de-DE' },
    en: { fill: 'Enter above what you want to have wrapped', min: ' (minimum charge)', step: 'Step ', of: ' of ', dur: ' · takes about a minute', loc: 'en-GB' }
  }[GW_LANG] || { fill: 'Vul hierboven in wat je wilt laten wrappen', min: ' (minimumtarief)', step: 'Stap ', of: ' van ', dur: ' · duurt ongeveer een minuut', loc: 'nl-NL' };

  function euro(n) {
    return '€' + Math.round(n).toLocaleString(GW_T.loc);
  }
  function round10(n) {
    return Math.round(n / 10) * 10;
  }

  function initCalc(box) {
    var price = {
      deur: parseFloat(box.getAttribute('data-deur')) || 0,
      lade: parseFloat(box.getAttribute('data-lade')) || 0,
      paneel: parseFloat(box.getAttribute('data-paneel')) || 0,
      blad: parseFloat(box.getAttribute('data-blad')) || 0
    };
    var min = parseFloat(box.getAttribute('data-min')) || 0;
    var out = box.querySelector('[data-vw-out]');
    var inputs = box.querySelectorAll('[data-vw-in]');
    var root = box.closest('.vnstra-wrap') || document;
    var summaryField = root.querySelector('[data-vw-summary]');
    var lastSummary = '';

    function val(key) {
      var el = box.querySelector('[data-vw-in="' + key + '"]');
      var v = el ? parseFloat(String(el.value).replace(',', '.')) : 0;
      if (!isFinite(v) || v < 0) v = 0;
      return v;
    }

    function update() {
      var q = { deur: val('deur'), lade: val('lade'), paneel: val('paneel'), blad: val('blad') };
      var total = q.deur * price.deur + q.lade * price.lade + q.paneel * price.paneel + q.blad * price.blad;
      var text;
      if (total <= 0) {
        text = GW_T.fill;
      } else if (total <= min) {
        text = euro(min) + GW_T.min;
      } else {
        var lo = Math.max(min, round10(total * 0.9));
        var hi = Math.max(min, round10(total * 1.1));
        text = euro(lo) + ' – ' + euro(hi);
      }
      if (out) out.textContent = text;
      lastSummary = q.deur + ' deurtjes, ' + q.lade + ' lades, ' + q.paneel + ' zijpanelen, ' +
        String(q.blad).replace('.', ',') + ' m aanrechtblad. Richtprijs: ' + text;
      if (summaryField) summaryField.value = lastSummary;
    }

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', update);
      inputs[i].addEventListener('change', update);
    }
    update();

    var toForm = box.querySelector('[data-vw-to-form]');
    if (toForm && summaryField) {
      toForm.addEventListener('click', function () {
        summaryField.value = lastSummary;
        var bericht = root.querySelector('#vw-bericht');
        if (bericht && !bericht.value) {
          bericht.value = 'Mijn samenstelling uit de rekenhulp: ' + lastSummary;
        }
        presetDoors(root, val('deur'));
      });
    }
  }


  /* Aanvraag in 4 stappen. Zonder JavaScript staan alle stappen gewoon onder elkaar. */
  function initSteps(form) {
    var steps = form.querySelectorAll('[data-vw-step]');
    if (steps.length < 2) return;
    var progress = form.querySelector('[data-vw-progress]');
    var fill = form.querySelector('[data-vw-progress-fill]');
    var bar = form.querySelector('[data-vw-progress-bar]');
    var txt = form.querySelector('[data-vw-progress-txt]');
    var total = steps.length;
    var current = 1;
    form.classList.add('is-stepped');
    if (progress) progress.hidden = false;

    function show(n, focus) {
      current = Math.max(1, Math.min(total, n));
      for (var i = 0; i < steps.length; i++) {
        var on = parseInt(steps[i].getAttribute('data-vw-step'), 10) === current;
        steps[i].hidden = !on;
      }
      if (fill) fill.style.width = (current / total * 100) + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(current));
      if (txt) txt.textContent = GW_T.step + current + GW_T.of + total + (current === 1 ? GW_T.dur : '');
      if (focus) {
        var legend = form.querySelector('[data-vw-step="' + current + '"] legend');
        if (legend) { legend.setAttribute('tabindex', '-1'); try { legend.focus({ preventScroll: true }); } catch (e) {} }
        try { form.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { form.scrollIntoView(); }
      }
    }

    function stepValid(n) {
      var step = form.querySelector('[data-vw-step="' + n + '"]');
      if (!step) return true;
      var fields = step.querySelectorAll('input, select, textarea');
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].willValidate && !fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    form.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-vw-next], [data-vw-prev]') : null;
      if (!t) return;
      e.preventDefault();
      if (t.hasAttribute('data-vw-next')) {
        if (stepValid(current)) show(current + 1, true);
      } else {
        show(current - 1, true);
      }
    });

    form.addEventListener('submit', function (e) {
      for (var n = 1; n <= total; n++) {
        if (!stepValid(n)) { e.preventDefault(); show(n, true); stepValid(n); return; }
      }
    });

    form.vwShow = show;
    var hasError = !!form.querySelector('.vnstra-wrap__err');
    show(hasError ? total : 1, false);
  }

  function presetDoors(root, count) {
    var radios = root.querySelectorAll('[data-vw-range]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i].getAttribute('data-vw-range').split('-');
      if (count >= parseInt(r[0], 10) && count <= parseInt(r[1], 10)) { radios[i].checked = true; break; }
    }
  }

  function initOk() {
    var ok = document.querySelector('[data-vw-ok]');
    if (ok) {
      try { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function init() {
    var boxes = document.querySelectorAll('[data-vw-calc]');
    for (var i = 0; i < boxes.length; i++) initCalc(boxes[i]);
    var forms = document.querySelectorAll('#vnstra-wrap-form');
    for (var j = 0; j < forms.length; j++) initSteps(forms[j]);
    initOk();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
